/* TAT theme. Plain JS, no dependencies. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var config = window.TAT || {};

  /* ------------------------------------------------------------------
     Dialogs (menu drawer, search, cart drawer, size guide, lightbox)
     ------------------------------------------------------------------ */
  function lockScroll() { document.documentElement.classList.add('is-locked'); }
  function unlockScrollIfIdle() {
    if (!document.querySelector('dialog[open]') && !document.querySelector('[data-filters].is-open')) {
      document.documentElement.classList.remove('is-locked');
    }
  }
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    lockScroll();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    unlockScrollIfIdle();
  }

  document.addEventListener('close', function (e) {
    if (e.target && e.target.tagName === 'DIALOG') unlockScrollIfIdle();
  }, true);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.getAttribute('data-open-dialog')));
      return;
    }
    var closer = e.target.closest('[data-close-dialog]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    // Click on the backdrop: the event target is the dialog element itself.
    if (e.target.tagName === 'DIALOG' && e.target.open) closeDialog(e.target);
  });

  /* ------------------------------------------------------------------
     Header: sticky wrapper + border once the page has scrolled
     ------------------------------------------------------------------ */
  var scrollBound = false;
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var wrap = header.closest('.shopify-section');
    if (wrap) wrap.classList.add('header-wrap');
    var update = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    update();
    if (!scrollBound) {
      window.addEventListener('scroll', update, { passive: true });
      scrollBound = true;
    }
  }

  /* ------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------ */
  function cartDialog() { return document.getElementById('cart-drawer'); }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function renderDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var live = $('[data-cart-drawer-inner]');
    if (!fresh || !live) return;
    live.replaceWith(fresh);
    updateCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data['cart-drawer']) renderDrawer(data['cart-drawer']); })
      .catch(function () {});
  }

  function showBuyError(form, message) {
    var box = form.querySelector('[data-buy-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  function addToCart(form) {
    var button = form.querySelector('[data-buy-button]');
    var label = button ? button.textContent : '';
    showBuyError(form, '');
    if (button) { button.disabled = true; button.classList.add('is-loading'); button.textContent = 'Adding'; }

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(config.cartAddUrl + '.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          showBuyError(form, result.data.description || result.data.message || 'That could not be added. Try again.');
          return;
        }
        if (result.data.sections && result.data.sections['cart-drawer']) {
          renderDrawer(result.data.sections['cart-drawer']);
        } else {
          refreshDrawer();
        }
        openDialog(cartDialog());
      })
      .catch(function () { showBuyError(form, 'Something went wrong. Try again in a moment.'); })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); button.textContent = label; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList) return;

    if (form.classList.contains('js-product-form') && config.cartType === 'drawer') {
      e.preventDefault();
      addToCart(form);
      return;
    }

    if (form.matches('form[data-newsletter]')) {
      e.preventDefault();
      submitNewsletter(form);
    }
  });

  function changeLine(line, quantity) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-busy');
    fetch(config.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        else refreshDrawer();
      })
      .catch(function () {
        var err = $('[data-cart-error]');
        if (err) { err.textContent = 'Could not update the cart. Try again.'; err.hidden = false; }
        if (inner) inner.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-trigger]');
    if (trigger && config.cartType === 'drawer' && cartDialog()) {
      e.preventDefault();
      openDialog(cartDialog());
      refreshDrawer();
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var lineEl = step.closest('[data-line]');
      var input = step.closest('[data-qty]').querySelector('[data-qty-input]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      changeLine(lineEl.getAttribute('data-line'), next);
      return;
    }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      changeLine(remove.closest('[data-line]').getAttribute('data-line'), 0);
      return;
    }

    var pdpStep = e.target.closest('[data-qty-step-input]');
    if (pdpStep) {
      var field = pdpStep.closest('.qty').querySelector('input');
      field.value = Math.max(1, (parseInt(field.value, 10) || 1) + parseInt(pdpStep.getAttribute('data-qty-step-input'), 10));
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest && e.target.closest('[data-qty-input]');
    if (qtyInput) {
      changeLine(qtyInput.closest('[data-line]').getAttribute('data-line'), Math.max(0, parseInt(qtyInput.value, 10) || 0));
      return;
    }

    var auto = e.target.closest && e.target.closest('[data-auto-submit]');
    if (!auto) return;
    var cartForm = auto.closest('[data-cart-page-form]');
    if (cartForm) {
      var updateBtn = cartForm.querySelector('[name="update"]');
      if (cartForm.requestSubmit) cartForm.requestSubmit(updateBtn || undefined);
      else cartForm.submit();
      return;
    }
    var collectionForm = auto.closest('[data-collection-form]');
    if (collectionForm) {
      clearTimeout(collectionForm._t);
      collectionForm._t = setTimeout(function () {
        if (collectionForm.requestSubmit) collectionForm.requestSubmit();
        else collectionForm.submit();
      }, 250);
    }
  });

  /* ------------------------------------------------------------------
     Promo codes. Codes and what they take off live in Shopify admin >
     Discounts; this only puts them on the cart.
     ------------------------------------------------------------------ */
  function sameCode(a, b) { return a.toUpperCase() === b.toUpperCase(); }

  function appliedCodes(box) {
    return $$('[data-discount-code]', box).map(function (el) { return el.getAttribute('data-discount-code'); });
  }

  function showDiscountError(box, message) {
    var el = $('[data-discount-error]', box);
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function postDiscounts(codes, withDrawer) {
    var body = { discount: codes.join(',') };
    if (withDrawer) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
    return fetch(config.cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('discount update failed');
      return r.json();
    });
  }

  function updateDiscounts(box, codes, tried) {
    var inDrawer = !!box.closest('[data-cart-drawer-inner]');
    var finish = function (cart, error) {
      if (!inDrawer) {
        if (error) { box.classList.remove('is-busy'); showDiscountError(box, error); }
        else window.location.reload();
        return;
      }
      if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
      var fresh = $('[data-cart-drawer-inner] [data-discount]');
      if (fresh && error) showDiscountError(fresh, error);
    };

    box.classList.add('is-busy');
    showDiscountError(box, '');
    postDiscounts(codes, inDrawer)
      .then(function (cart) {
        var ok = !tried || (cart.discount_codes || []).some(function (d) { return d.applicable && sameCode(d.code, tried); });
        if (ok) return finish(cart, '');
        // Shopify keeps a code on the cart even when it doesn't apply, so take it back off.
        var rest = codes.filter(function (c) { return !sameCode(c, tried); });
        return postDiscounts(rest, inDrawer).then(function (clean) {
          finish(clean, '"' + tried + '" isn\'t a working code for this cart.');
        });
      })
      .catch(function () {
        box.classList.remove('is-busy');
        showDiscountError(box, 'Could not update the code. Try again.');
      });
  }

  function applyDiscount(box) {
    var input = $('[data-discount-input]', box);
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    var codes = appliedCodes(box);
    if (codes.some(function (c) { return sameCode(c, code); })) {
      showDiscountError(box, 'That code is already on your cart.');
      return;
    }
    updateDiscounts(box, codes.concat(code), code);
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-discount-apply]');
    if (apply) { applyDiscount(apply.closest('[data-discount]')); return; }
    var remove = e.target.closest('[data-discount-remove]');
    if (remove) {
      var box = remove.closest('[data-discount]');
      var gone = remove.closest('[data-discount-code]').getAttribute('data-discount-code');
      updateDiscounts(box, appliedCodes(box).filter(function (c) { return c !== gone; }), null);
    }
  });

  // Enter in the code field applies it instead of submitting the checkout form around it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('[data-discount-input]')) return;
    e.preventDefault();
    applyDiscount(e.target.closest('[data-discount]'));
  });

  /* ------------------------------------------------------------------
     Brand intro: scroll position picks the line and opens the photo.
     Native scroll only; reduced motion gets the plain stacked version.
     ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var intros = [];
  var introTicking = false;

  function updateIntro(intro) {
    var section = intro.el;
    if (!section.classList.contains('is-live')) return;
    var travel = Math.max(section.offsetHeight - window.innerHeight, 1);
    var p = Math.min(Math.max(-section.getBoundingClientRect().top / travel, 0), 1);
    section.style.setProperty('--p', p.toFixed(4));
    var i = Math.min(intro.steps.length - 1, Math.floor(p * intro.steps.length));
    if (i === intro.current) return;
    intro.current = i;
    intro.steps.forEach(function (step, n) {
      step.classList.toggle('is-active', n === i);
      step.classList.toggle('is-past', n < i);
    });
    if (intro.index) intro.index.textContent = i + 1;
  }

  function onIntroScroll() {
    if (introTicking) return;
    introTicking = true;
    requestAnimationFrame(function () {
      introTicking = false;
      intros = intros.filter(function (intro) { return document.contains(intro.el); });
      intros.forEach(updateIntro);
    });
  }

  function setIntroMode(intro) {
    var live = !reduceMotion.matches && intro.steps.length > 1;
    intro.el.classList.toggle('is-live', live);
    intro.current = -1;
    if (live) { updateIntro(intro); return; }
    intro.el.style.removeProperty('--p');
    intro.steps.forEach(function (step) { step.classList.remove('is-active', 'is-past'); });
  }

  function initIntro(section) {
    if (section.getAttribute('data-ready')) return;
    section.setAttribute('data-ready', '1');
    var intro = {
      el: section,
      steps: $$('[data-intro-step]', section),
      index: $('[data-intro-index]', section),
      current: -1
    };
    intros.push(intro);
    setIntroMode(intro);

    // Tabbing to a line that isn't showing yet (the button on the last one) scrolls to it.
    section.addEventListener('focusin', function (e) {
      if (!section.classList.contains('is-live')) return;
      var n = intro.steps.indexOf(e.target.closest('[data-intro-step]'));
      if (n < 0 || n === intro.current) return;
      var travel = section.offsetHeight - window.innerHeight;
      var top = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, top + travel * (n + 0.5) / intro.steps.length);
    });

    var skip = $('[data-intro-skip]', section);
    if (skip) skip.addEventListener('click', function () {
      var wrap = section.closest('.shopify-section') || section;
      var next = wrap.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });
  }

  window.addEventListener('scroll', onIntroScroll, { passive: true });
  window.addEventListener('resize', onIntroScroll);
  var onMotionChange = function () { intros.forEach(setIntroMode); };
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
  else if (reduceMotion.addListener) reduceMotion.addListener(onMotionChange);

  /* ------------------------------------------------------------------
     Collection filters (drawer on small screens)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle-filters]');
    if (!toggle) return;
    var panel = $('[data-filters]');
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    $$('[data-toggle-filters][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) lockScroll(); else unlockScrollIfIdle();
  });

  /* ------------------------------------------------------------------
     Newsletter: submit in the background, confirm in place
     ------------------------------------------------------------------ */
  function submitNewsletter(form) {
    var status = $('[data-newsletter-status]', form);
    var button = $('button[type="submit"]', form);
    var email = $('input[type="email"]', form);
    if (email && !email.checkValidity()) { email.reportValidity(); return; }
    if (button) button.disabled = true;

    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (res.url && res.url.indexOf('/challenge') !== -1) { form.submit(); return; }
        if (!res.ok) throw new Error('signup failed');
        var code = status ? status.getAttribute('data-discount-code') : '';
        if (status) {
          status.classList.remove('is-error');
          status.textContent = "You're on the list.";
          if (code) {
            var strong = document.createElement('strong');
            strong.textContent = code;
            status.appendChild(document.createTextNode(' Use code '));
            status.appendChild(strong);
            status.appendChild(document.createTextNode(' at checkout.'));
          }
        }
        form.classList.add('is-done');
      })
      .catch(function () {
        if (status) { status.classList.add('is-error'); status.textContent = 'Something went wrong. Try again in a moment.'; }
      })
      .then(function () { if (button) button.disabled = false; });
  }

  /* ------------------------------------------------------------------
     Product page
     ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.getAttribute('data-ready')) return;
    section.setAttribute('data-ready', '1');

    var json = $('[data-product-json]', section);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var sectionId = section.getAttribute('data-section-id');
    var groups = $$('[data-option-group]', section);
    var track = $('[data-gallery-track]', section);
    var mobile = window.matchMedia('(max-width: 899px)');

    function selectedOptions() {
      return groups.map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function setUnavailable() {
      $$('[data-buy-button], .sticky-atc__btn', section).forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
      });
    }

    function scrollToVariantMedia(variant) {
      if (!track || !variant.featured_media || !mobile.matches) return;
      var target = $('[data-media-id="' + variant.featured_media.id + '"]', track);
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    function onOptionChange() {
      var picked = selectedOptions();
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === picked[i]; });
      })[0];
      if (!variant) { setUnavailable(); return; }

      fetch(product.url + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          $$('[data-swap]', section).forEach(function (el) {
            var source = doc.querySelector('[data-swap="' + el.getAttribute('data-swap') + '"]');
            if (source) el.innerHTML = source.innerHTML;
          });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(null, '', url.toString());
          if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
          scrollToVariantMedia(variant);
        })
        .catch(function () {});
    }

    groups.forEach(function (group) { group.addEventListener('change', onOptionChange); });

    /* Phone gallery dots follow the swipe position. */
    var dots = $$('.gallery__dot', section);
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      }, { passive: true });
    }

    /* Enlarge photo. */
    var lightbox = $('[data-lightbox]', section);
    section.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-zoom]');
      if (!zoom || !lightbox) return;
      var img = $('[data-lightbox-img]', lightbox);
      img.src = zoom.getAttribute('data-zoom-src');
      img.alt = zoom.getAttribute('data-zoom-alt') || '';
      openDialog(lightbox);
    });

    /* Sticky add to cart: only while the real button is out of view. */
    var sticky = $('[data-sticky-atc]', section);
    var anchor = $('[data-swap="buy"]', section);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(anchor);
    }
  }

  /* Related products load after the page, from Shopify's recommendations endpoint. */
  function initRecs(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var load = function () {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-recs]', doc);
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(el);
    } else {
      load();
    }
  }

  /* Address form: preselect the saved country. */
  function initCountrySelects(root) {
    $$('select[data-default]', root).forEach(function (select) {
      var value = select.getAttribute('data-default');
      if (value) select.value = value;
    });
  }

  function initAll(root) {
    initHeader();
    $$('[data-intro]', root).forEach(initIntro);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-recs]', root).forEach(initRecs);
    initCountrySelects(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Back/forward cache can show a stale cart count. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCount(cart.item_count); })
        .catch(function () {});
    }
  });
})();
